export class PortalRegion {
    id: number;
    name: string;
    displayName: string;
    features: PortalFeature[];
}

export class PortalFeatureCard {
    id: PortalFeatureEnum;
    name: string;
    description: string;
    shortDescription: string;
    displayName: string;
    platforms: string[];
    isAutoCad?: boolean;
    downloadDataTrack?: string;
    loginRequired?: boolean;
}

export class PortalFeature {
    public id: PortalFeatureEnum;
    public url: string | null;
}

export enum PortalFeatureEnum {
    AutoCad = 1, // ........Download
    BSS = 2, // ............Construct Modul
    Cablefilling = 3, // ...Construct Modul
    Egress = 4, // .........Construct Modul
    Photovoltaic = 5, // ...Construct Modul
    GRD = 6, // ............Construct Modul
    TBS = 7, // ............Construct Modul
    UFS = 8, // ...........Construct Modul
    Video = 9 // .........Construct Tutorial
}

export function hasDownloadCondition(featureId: number): boolean {
    return featureId === PortalFeatureEnum.AutoCad;
}

export function hasConstructModuleCondition(featureId: number): boolean {
    return (
        featureId === PortalFeatureEnum.BSS ||
        featureId === PortalFeatureEnum.Cablefilling ||
        featureId === PortalFeatureEnum.UFS ||
        featureId === PortalFeatureEnum.GRD ||
        featureId === PortalFeatureEnum.TBS ||
        featureId === PortalFeatureEnum.Photovoltaic ||
        featureId === PortalFeatureEnum.Egress
    );
}
